"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const uuid_1 = require("uuid");
const functions_1 = require("../nevada-shared/functions");
const SharedTypes = __importStar(require("../nevada-shared/types"));
const initialState = {
    inputRows: [
        {
            id: (0, uuid_1.v4)(),
            genesysNo: "147734-240"
        },
        {
            id: (0, uuid_1.v4)(),
            genesysNo: "147738-200"
        },
        {
            id: (0, uuid_1.v4)(),
            genesysNo: "180804-1"
        }
    ],
    systemsToTest: [],
    showResult: false,
    running: false,
    runningSize: 3,
    currentIndex: 0,
    currentBatch: new Set()
};
function reducer(
// biome-ignore lint: -
state = initialState, action) {
    switch (action.type) {
        case "nevada/RUN-TEST":
            return Object.assign({}, state);
        case "nevada/ADD-TEST":
            return Object.assign(Object.assign({}, state), { inputRows: [
                    ...state.inputRows,
                    {
                        id: (0, uuid_1.v4)(),
                        genesysNo: ""
                    }
                ] });
        case "nevada/DELETE-TEST":
            return Object.assign(Object.assign({}, state), { inputRows: state.inputRows
                    .slice(0, action.index)
                    .concat(state.inputRows.slice(action.index + 1)) });
        case "nevada/SET-GENESYS-NO":
            return Object.assign(Object.assign({}, state), { inputRows: state.inputRows.map((r, ix) => ix === action.index ? Object.assign(Object.assign({}, r), { genesysNo: action.text }) : r) });
        case "nevada/REPLACE-GENESYS-NO":
            return Object.assign(Object.assign({}, state), { inputRows: action.texts.map((t) => ({
                    id: (0, uuid_1.v4)(),
                    genesysNo: t
                })) });
        case "nevada/SHOW-RESULT": {
            const currentIndex = Math.min(state.runningSize, action.systemsToTest.length);
            const firstBatch = action.systemsToTest.slice(0, currentIndex);
            const waitingSystems = action.systemsToTest
                .slice(currentIndex)
                .map((s) => {
                return Object.assign(Object.assign({}, s), { status: SharedTypes.Status.Waiting });
            });
            const systemsToTest = [...firstBatch, ...waitingSystems];
            return Object.assign(Object.assign({}, state), { showResult: action.show, currentIndex: currentIndex, currentBatch: new Set(firstBatch.map((x) => x.internalId)), systemsToTest: systemsToTest, running: true });
        }
        case "nevada/SET-RUNNING":
            return Object.assign(Object.assign({}, state), { running: action.running });
        case "nevada/SET-RUNNING-SIZE": {
            return Object.assign(Object.assign({}, state), { runningSize: action.size });
        }
        case "nevada/SET-TEST-SYSTEM": {
            const index = state.systemsToTest.findIndex((s) => s.internalId === action.system.internalId);
            const testSystems = state.systemsToTest
                .slice(0, index)
                .concat(action.system)
                .concat(state.systemsToTest.slice(index + 1));
            const running = !testSystems.every((t) => t.status === SharedTypes.Status.Complete);
            const runningSytems = state.currentBatch;
            let currentIndex = state.currentIndex;
            if (action.system.status === SharedTypes.Status.Complete) {
                runningSytems.delete(action.system.internalId);
            }
            if (runningSytems.size < state.runningSize &&
                currentIndex < state.systemsToTest.length) {
                const system = Object.assign(Object.assign({}, state.systemsToTest[currentIndex]), { status: SharedTypes.Status.Idle });
                testSystems[currentIndex] = system;
                runningSytems.add(system.internalId);
                // biome-ignore lint: -
                currentIndex = currentIndex + 1;
            }
            return Object.assign(Object.assign({}, state), { systemsToTest: testSystems, currentIndex: currentIndex, running: running });
        }
        case "nevada/toggle-node-children": {
            const systemIndex = state.systemsToTest.findIndex((s) => s.internalId === action.testId);
            const system = state.systemsToTest[systemIndex];
            const nodeIndex = state.systemsToTest[systemIndex].result.nodes.findIndex((n) => action.path[0] === n.id);
            const node = state.systemsToTest[systemIndex].result.nodes[nodeIndex];
            const updatedNode = (0, functions_1.toggleNode)(node, action.path, 0);
            const updatedSystem = Object.assign(Object.assign({}, system), { result: {
                    type: "result",
                    warnings: system.result.warnings,
                    nodes: system.result.nodes
                        .slice(0, nodeIndex)
                        .concat(updatedNode)
                        .concat(system.result.nodes.slice(nodeIndex + 1))
                } });
            return Object.assign(Object.assign({}, state), { systemsToTest: state.systemsToTest
                    .slice(0, systemIndex)
                    .concat(updatedSystem)
                    .concat(state.systemsToTest.slice(systemIndex + 1)) });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map